module.exports = __webpack_public_path__ + "static/media/5.25a716c4.svg";